import { render, staticRenderFns } from "./SubmitRequest.vue?vue&type=template&id=4571ecc7&"
import script from "./SubmitRequest.vue?vue&type=script&lang=ts&"
export * from "./SubmitRequest.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports